import Vue from 'vue';
import './plugins/axios';
import './components';
import './plugins';
import {
  sync
} from 'vuex-router-sync';

import App from './App';
import router from './router/index';
import store from '@/store';
import './plugins/helper';

import {
  VTooltip,
} from 'v-tooltip';

import Axios from 'axios';
Vue.directive('tooltip', VTooltip);

// use toastr
import CxltToastr from 'cxlt-vue2-toastr'

const toastrConfigs = {
  position: 'top right',
  showDuration: 1000,
  timeOut: 5000,
  progressBar: true
}

Vue.use(CxltToastr, toastrConfigs)

// use epic-spinner
// import {
//   SwappingSquaresSpinner
// } from 'epic-spinners'

// Vue.use(SwappingSquaresSpinner)

// Sync store with router
sync(store, router);

Vue.config.productionTip = false;

window.Bus = new Vue;
window.Axios = axios;

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');